import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { LANGUAGES } from '../../../config/consts';
import actions from '../../../modules/cookies';
import { useAppContext } from '../../App/AppContextProvider';

export function useLoginFlowsWrapper() {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { currentUserLang } = useAppContext();
  const yearTo = new Date().getFullYear().toString();

  useEffect(() => {
    dispatch(actions.setGlobalCookieSettingsIconShown(false));
    return () => {
      dispatch(actions.setGlobalCookieSettingsIconShown(true));
    };
  }, []);

  const links2nMap = {
    [LANGUAGES.czech.locale]:
      'https://www.2n.com/cs-CZ/newsroom/zabezpecte-my2n-vicefaktorovym-overovanim/?utm_source=My2N&utm_campaign=My2N_multifactor&utm_content=lang_CZ',
    [LANGUAGES.german.locale]:
      'https://www.2n.com/de-DE/newsroom/sicherheit-von-my2n-durch-multi-faktor-authentifizierung-verbessert/?utm_source=My2N&utm_campaign=My2N_multifactor&utm_content=lang_DE',
    [LANGUAGES.english.locale]:
      'https://www.2n.com/en-GB/newsroom/security-of-my2n-enhanced-with-multi-factor-authentication/?utm_source=My2N&utm_campaign=My2N_multifactor&utm_content=lang_EN',
    [LANGUAGES.spanish.locale]:
      'https://www.2n.com/es-ES/newsroom/seguridad-de-my2n-mejorada-con-autenticacion-multifactor/?utm_source=My2N&utm_campaign=My2N_multifactor&utm_content=lang_ES',
    [LANGUAGES.french.locale]:
      'https://www.2n.com/fr-FR/newsroom/la-securite-de-my2n-renforcee-par-lauthentification-multifactorielle/?utm_source=My2N&utm_campaign=My2N_multifactor&utm_content=lang_FR',
    [LANGUAGES.italian.locale]:
      'https://www.2n.com/it-IT/newsroom/sicurezza-di-my2n-migliorata-con-lautenticazione-a-piu-fattori/?utm_source=My2N&utm_campaign=My2N_multifactor&utm_content=lang_IT',
    [LANGUAGES.dutch.locale]:
      'https://www.2n.com/nl-NL/newsroom/beveiliging-van-my2n-verbeterd-met-multi-factor-authenticatie/?utm_source=My2N&utm_campaign=My2N_multifactor&utm_content=lang_NL',
    [LANGUAGES.finnish.locale]:
      'https://www.2n.com/en-GB/newsroom/security-of-my2n-enhanced-with-multi-factor-authentication/?utm_source=My2N&utm_campaign=My2N_multifactor&utm_content=lang_EN',
  };

  return {
    currentUserLang,
    dispatch,
    formatMessage,
    link2N: links2nMap[currentUserLang!],
    yearTo,
  };
}
